import React, { useState } from "react";
import ApiCustom from "../utils/ApiCustom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Mật khẩu phải có ít nhất 8 ký tự")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      "Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt"
    )
    .required("Mật khẩu không được để trống"),
  rePassword: Yup.string()
    .required("Mat khẩu xác nhận không được để trống")
    .oneOf([Yup.ref("password"), null], "Mật khẩu xác nhận không khớp"),
});

const ResetPasswordForm = ({ onBack, email, onChangeEmail }) => {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;

  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   setErrors((prev) => ({ ...prev, [name]: "" }));

  //   try {
  //     await Yup.reach(userSchema, name).validate(value);
  //     setErrors((prev) => ({ ...prev, [name]: undefined }));
  //   } catch (validationError) {
  //     setErrors((prev) => ({ ...prev, [name]: validationError.message }));
  //   }
  // };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = {
        email: email,
        otpCode: otp,
        password: password,
      };

      const validateFormData = {
        ...formData,
        rePassword: rePassword,
      };

      await passwordSchema.validate(validateFormData, { abortEarly: false });

      setLoading(true);

      const response = await ApiCustom.post("/user-reset-password", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        toast.success("Mật khẩu đã được đặt lại thành công!");
        setLoading(false);
        onBack();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
        console.log("Validation errors:", formErrors);
      } else {
        toast.error(error.response?.data?.messages || "Có lỗi xảy ra!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-base-100 shadow-lg rounded-lg p-6 w-80">
      <h2 className="text-2xl font-bold text-center mb-4">Đặt lại mật khẩu</h2>
      <div className="space-y-4">
        <div>
          <input
            type="text"
            id="otp"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Nhập mã OTP"
            required
            disabled={loading}
          />
        </div>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.userCode ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Nhập mật khẩu mới"
            required
            disabled={loading}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 focus:outline-none"
          >
            {showPassword ? (
              <span className="text-sm">
                <EyeIcon className="h-6 w-6 text-gray-500" />
              </span>
            ) : (
              <span className="text-sm">
                <EyeSlashIcon className="h-6 w-6 text-gray-500" />
              </span>
            )}
          </button>
        </div>
        {errors.password && (
          <p className="mt-1 text-sm text-red-600">{errors.password}</p>
        )}
        <div className="relative">
          <input
            type={showRePassword ? "text" : "password"}
            id="rePassword"
            value={rePassword}
            onChange={(e) => setRePassword(e.target.value)}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.userCode ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Nhập lại mật khẩu mới"
            required
            disabled={loading}
          />
          <button
            type="button"
            onClick={toggleRePasswordVisibility}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 focus:outline-none"
          >
            {showRePassword ? (
              <span className="text-sm">
                <EyeIcon className="h-6 w-6 text-gray-500" />
              </span>
            ) : (
              <span className="text-sm">
                <EyeSlashIcon className="h-6 w-6 text-gray-500" />
              </span>
            )}
          </button>
        </div>
        {errors.rePassword && (
          <p className="mt-1 text-sm text-red-600">{errors.rePassword}</p>
        )}
        <div className="mb-2 text-[14px]">
          <span className="text-red-500">* </span>Mã xác thực đã được gửi về
          email của bạn (<strong>{email}</strong>)
        </div>
        <div className="flex justify-end">
          <span
            className="text-blue-500 cursor-pointer inline-block"
            onClick={onChangeEmail}
          >
            Đổi email khác
          </span>
        </div>
        <div className="flex justify-between">
          <button
            type="button"
            onClick={onBack}
            className="btn py-2 rounded-md transition duration-300 btn-sm"
            disabled={loading}
          >
            Quay lại
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 rounded-md transition duration-300 btn-sm"
            disabled={loading}
            onClick={handleResetPasswordSubmit}
          >
            {loading ? "Đang gửi..." : "Đặt lại mật khẩu"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
